import RegionsList from './RegionsList';

export default RegionsList;



// WEBPACK FOOTER //
// ./src/scenes/Regions/components/RegionsList/index.ts